export const workFlowStepsConstants: Record<string, string> = {
    step1: 'UploadMapValidate',
    step2: 'RawFeedImgProcess',
    step3: 'RawFeedPopulateMasterData',
    step4: 'RawFeedProductInfoGeneration',
    step5: 'RawFeedproductCategorization',
    step6: "RawFeedShippingAnalysis",
    step7: "RawFeedPublishToStage",
    step8: "RawFeedPublishToProd",

};

export const workFlowStepsConstantsReverse: Record<string, number> = {
    'UploadMapValidate': 1,
    'RawFeedImgProcess': 2,
    'RawFeedPopulateMasterData': 3,
    'RawFeedProductInfoGeneration': 4,
    'RawFeedproductCategorization': 5,
    'RawFeedShippingAnalysis': 6,
    'RawFeedPublishToStage': 7,
    'RawFeedPublishToProd': 8,
};